import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import MaterialTable from "material-table";
import TablePagination from "@material-ui/core/TablePagination";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
// import PtsButton from "../../givBee/buttons/PtsButton";
import Utils from "../../../provider/Utils";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import { EventList_Url } from "../../../provider/ServiceUrl";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
class AccountEventList extends Component {
  header = store.getState().adminHeader.adminHeader;
  breadCrumb = [
    { pageid: "/accountList", uiname: "Accounts List" },
    { pageid: "/viewAccount", uiname: "Account" },
    { pageid: "", uiname: "Events" },
  ];
  eventState = store.getState().applicationState.eventState;
  planType = store.getState().appUserData.appUserData.planType?.type;
  eventStateDetails = {};
  constructor(props) {
    super(props);
    let accountId = "";
    let businessDomain = null;
    if (props.state) {
      accountId = props.state.accountId;
      businessDomain = props.state.businessDomain;
    }
    if (this.eventState) {
      this.eventStateDetails = Object.getOwnPropertyNames(this.eventState);
    }
    if (this.eventStateDetails.length > 0) {
      this.state = {
        accountId: accountId,
        businessDomain: businessDomain,
        action: props.action,
        initialPage: this.eventState.initialPage,
        pageSize: this.eventState.pageSize,
        eventList: [],
        futureEventList: [],
        activeEventList: [],
        pastEventList: [],
        cancelledEventList: [],
        render: false,
        getCreatePermission: false,
        isFutureEventListPaging: false,
        isActiveEventListPaging: false,
        isPastEventListPaging: false,
        isCancelledEventListPaging: false,
        eventId: this.eventState.eventId,
      };
    } else {
      this.state = {
        accountId: accountId,
        action: props.action,
        businessDomain: businessDomain,
        selectedTab: 0,
        initialPage: 0,
        pageSize: 20,
        eventList: [],
        futureEventList: [],
        activeEventList: [],
        pastEventList: [],
        cancelledEventList: [],
        render: false,
        getCreatePermission: false,
        isFutureEventListPaging: false,
        isActiveEventListPaging: false,
        isPastEventListPaging: false,
        isCancelledEventListPaging: false,
        eventId: "",
      };
    }
    this.getEventList();
  }

  getEventList() {
    const postObject = {
      header: {
        ...this.header,
        tid: this.state.accountId,
      },
    };

    AdminFetchServerData.callPostService(EventList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let eventList = output.data.eventList;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getCreatePermission = getPermission[1];

          let isFutureEventListPaging = false;
          let isActiveEventListPaging = false;
          let isPastEventListPaging = false;
          let isCancelledEventListPaging = false;
          let futureEventList = [];
          let activeEventList = [];
          let pastEventList = [];
          let cancelledEventList = [];

          for (let i = 0; i < eventList.length; i++) {
            eventList[i].startDate = Utils.ptsDateFormat(
              eventList[i].startDate
            );
            eventList[i].endDate = Utils.ptsDateFormat(eventList[i].endDate);
            eventList[i].createdon = Utils.ptsDateFormat(
              eventList[i].createdon
            );
            eventList[i].creditsAvailable = Utils.formatWithCommas(
              eventList[i].creditsAvailable
            );
            eventList[i].creditsConsumed = Utils.formatWithCommas(
              eventList[i].creditsConsumed
            );

            if (Utils.equalsIgnoreCase(eventList[i].status, "Future")) {
              futureEventList.push(eventList[i]);
            } else if (Utils.equalsIgnoreCase(eventList[i].status, "Active")) {
              activeEventList.push(eventList[i]);
            } else if (Utils.equalsIgnoreCase(eventList[i].status, "Past")) {
              pastEventList.push(eventList[i]);
            } else if (
              Utils.equalsIgnoreCase(eventList[i].status, "Cancelled")
            ) {
              cancelledEventList.push(eventList[i]);
            }
          }

          for (let i = 0; i < futureEventList.length; i++) {
            futureEventList[i].rowNum = i + 1;
          }
          for (let i = 0; i < activeEventList.length; i++) {
            activeEventList[i].rowNum = i + 1;
          }
          for (let i = 0; i < pastEventList.length; i++) {
            pastEventList[i].rowNum = i + 1;
          }
          for (let i = 0; i < cancelledEventList.length; i++) {
            cancelledEventList[i].rowNum = i + 1;
          }

          if (futureEventList.length > this.state.pageSize) {
            isFutureEventListPaging = true;
          }
          if (futureEventList.length > this.state.pageSize) {
            isActiveEventListPaging = true;
          }
          if (pastEventList.length > this.state.pageSize) {
            isPastEventListPaging = true;
          }
          if (pastEventList.length > this.state.pageSize) {
            isCancelledEventListPaging = true;
          }

          this.setState({
            render: true,
            futureEventList: futureEventList,
            activeEventList: activeEventList,
            pastEventList: pastEventList,
            cancelledEventList: cancelledEventList,
            isFutureEventListPaging: isFutureEventListPaging,
            isActiveEventListPaging: isActiveEventListPaging,
            isPastEventListPaging: isPastEventListPaging,
            isCancelledEventListPaging: isCancelledEventListPaging,
            initialPage: this.state.initialPage,
            getCreatePermission: getCreatePermission,
          });
        }
      }
    );
  }

  setKey(tab) {
    this.setState({
      selectedTab: tab,
    });
  }

  async addEvent() {
    this.props.navigate("/event", {
      state: {
        action: "create",
      },
    });
  }

  toEventDetails(e, data) {
    let eventState = {
      eventId: data.id,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(ApplicationStateAction.setApplicationState({ eventState }));
    this.setState({
      action: "view",
      eventId: data.id,
      profileList: this.state.profileList,
    });
  }

  toProfileDetails(e, data) {
    if (
      this.referenceProfileDialogueRef &&
      this.referenceProfileDialogueRef.current
    ) {
      this.referenceProfileDialogueRef.current.getProfileDetails(
        data.profileId
      );
    }
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  viewEventDetails(data) {
    this.props.navigate("/accountSendHistory", {
      state: {
        businessDomain: this.state.businessDomain,
        accountId: this.state.accountId,
        eventId: data.id,
        eventName: data.name,
      },
    });
  }

  showEventDetails(rowData) {
    return (
      <>
        <span
          className="anchortag"
          onClick={this.viewEventDetails.bind(this, rowData)}
        >
          {rowData.name}
        </span>
      </>
    );
  }

  viewCancel() {
    this.props.navigate("/viewAccount", {
      state: {
        action: "view",
        accountId: this.state.accountId,
      },
    });
  }

  handleIsOptinRequiredChange = (e, rowData) => {
    const checked = e.target.checked;

    const updatedList = this.state.activeEventList.map((event) =>
      event.id === rowData.id
        ? { ...event, isOptinRequired: checked }
        : event
    );

    this.setState({ activeEventList: updatedList });
  };

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <AdminMenuWithBreadScrum
          backCallback={this.viewCancel.bind(this)}
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name="Events"
        />
        <div style={{ maxWidth: "100%", marginTop: "0.5em" }} id="eventList">
          <Tabs
            defaultIndex={this.state.selectedTab}
            onSelect={(k) => this.setKey(k)}
          >
            <TabList
              style={{ listStyle: "none" }}
              className="text-start d-flex flex-wrap justify-content-start ps-0 mb-0"
            >
              <Tab className="tabSetting hoverTab">
                <span className="tabCompleted">Current & Upcoming</span>
              </Tab>
              <Tab className="tabSetting hoverTab">
                <span className="tabCompleted">History</span>
              </Tab>
            </TabList>
            <TabPanel className="apMaterialTable">
              <MaterialTable
                title=""
                icons={UiUtils.getMaterialTableIcons()}
                localization={{
                  body: {
                    emptyDataSourceMessage: <h5>Please add event</h5>,
                  },
                }}
                columns={[
                  {
                    title: "#",
                    render: (rowData) => rowData.tableData.id + 1,
                    width: "5%",
                    align: "left",
                    cellStyle: {
                      width: "6%",
                    },
                  },
                  {
                    title: "Event name",
                    field: "name",
                    render: (rowData) => (
                      <div key={rowData.id}>
                        {this.showEventDetails(rowData)}
                      </div>
                    ),
                    cellStyle: {
                      width: "14%",
                    },
                  },
                  {
                    title: "Cvent Code",
                    field: "code",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "Start date",
                    field: "startDate",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "End date",
                    field: "endDate",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "Created on",
                    field: "createdon",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  // {
                  //   title: "Location",
                  //   field: "location",
                  //   cellStyle: {
                  //     width: "15%",
                  //   },
                  // },
                  {
                    title: "Text Usage",
                    render: (rowData) =>
                      `${rowData?.consumedCredits} /
                      ${rowData?.availableCredits}`,
                    cellStyle: {
                      width: "10%",
                    },
                  },
                  {
                    title: "Status",
                    field: "status",
                    filtering: false,
                    cellStyle: {
                      width: "8%",
                    },
                  },
                  {
                    title: "Text Opt-in Rqd",
                    render: (rowData) => (
                      <span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={this.state.isOptinRequired}
                            value={this.state.isOptinRequired}
                            onChange={(e) =>
                              this.handleIsOptinRequiredChange(e, rowData)
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </span>
                    ),
                    cellStyle: {
                      width: "16%",
                    },
                  }
                ]}
                data={this.state.activeEventList}
                options={{
                  toolbarButtonAlignment: "left",
                  sorting: true,
                  actionsColumnIndex: -1,
                  initialPage: this.state.initialPage,
                  pageSize: this.state.pageSize,
                  paging: this.state.isActiveEventListPaging,
                  headerStyle: {
                    fontWeight: "bold",
                    color: "#ffff",
                    align: "left",
                    backgroundColor: "#37517e",
                  },
                  rowStyle: (rowData) => ({
                    backgroundColor:
                      rowData.id === this.state.eventId ? "#e6effc" : "",
                    height: "3em",
                    textTransform: "capitalize",
                  }),
                }}
                // actions={[
                //   {
                //     icon: () =>
                //       Utils.equalsIgnoreCase(this.planType, "Onetime") ? (
                //         <PtsButton btnName="Purchase Event" type="submit" />
                //       ) : (
                //         <PtsButton btnName="Add Event" type="submit" />
                //       ),
                //     isFreeAction: true,
                //     onClick: (event) => this.addEvent(),
                //   },
                // ]}
                onChangePage={(page, pageSize) => {
                  this.handleMaterialTablePageChange(page, pageSize);
                }}
                components={{
                  Pagination: (props) => {
                    const {
                      page,
                      count,
                      rowsPerPage,
                      onPageChange,
                      onRowsPerPageChange,
                    } = props;

                    const totalPages = Math.ceil(count / rowsPerPage);
                    const currentPage = page + 1;

                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0 1rem",
                        }}
                      >
                        <div>
                          Page {currentPage} of {totalPages}
                        </div>
                        <TablePagination
                          {...props}
                          component="div"
                          count={count}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={onPageChange}
                          rowsPerPageOptions={Utils.materialTablePageSize()}
                          onRowsPerPageChange={onRowsPerPageChange}
                        />
                      </div>
                    );
                  },
                }}
              />
            </TabPanel>
            <TabPanel className="materialTable">
              <MaterialTable
                title=""
                icons={UiUtils.getMaterialTableIcons()}
                localization={{
                  body: {
                    emptyDataSourceMessage: <h5>Please add event</h5>,
                  },
                }}
                columns={[
                  {
                    title: "#",
                    render: (rowData) => rowData.tableData.id + 1,
                    width: "5%",
                    align: "left",
                    cellStyle: {
                      width: "6%",
                    },
                  },
                  {
                    title: "Event name",
                    field: "name",
                    render: (rowData) => (
                      <div key={rowData.id}>
                        {this.showEventDetails(rowData)}
                      </div>
                    ),
                    cellStyle: {
                      width: "16%",
                    },
                  },
                  {
                    title: "Cvent Code",
                    field: "code",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "Start date",
                    field: "startDate",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "End date",
                    field: "endDate",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "Created on",
                    field: "createdon",
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  // {
                  //   title: "Location",
                  //   field: "location",
                  //   cellStyle: {
                  //     width: "15%",
                  //   },
                  // },
                  {
                    title: "Text Usage",
                    render: (rowData) =>
                      `${rowData?.consumedCredits} /
                      ${rowData?.availableCredits}`,
                    cellStyle: {
                      width: "12%",
                    },
                  },
                  {
                    title: "Status",
                    field: "status",
                    filtering: false,
                    cellStyle: {
                      width: "12%",
                    },
                  },
                ]}
                data={this.state.pastEventList}
                options={{
                  sorting: true,
                  actionsColumnIndex: -1,
                  initialPage: this.state.initialPage,
                  pageSize: this.state.pageSize,
                  paging: this.state.isPastEventListPaging,
                  headerStyle: {
                    fontWeight: "bold",
                    color: "#ffff",
                    align: "left",
                    backgroundColor: "#37517e",

                  },
                  rowStyle: (rowData) => ({
                    backgroundColor:
                      rowData.id === this.state.eventId ? "#e6effc" : "",
                    height: "3em",
                    textTransform: "capitalize",
                  }),
                }}
                onChangePage={(page, pageSize) => {
                  this.handleMaterialTablePageChange(page, pageSize);
                }}
                components={{
                  Pagination: (props) => {
                    const {
                      page,
                      count,
                      rowsPerPage,
                      onPageChange,
                      onRowsPerPageChange,
                    } = props;

                    const totalPages = Math.ceil(count / rowsPerPage);
                    const currentPage = page + 1;

                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0 1rem",
                        }}
                      >
                        <div>
                          Page {currentPage} of {totalPages}
                        </div>
                        <TablePagination
                          {...props}
                          component="div"
                          count={count}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={onPageChange}
                          rowsPerPageOptions={Utils.materialTablePageSize()}
                          onRowsPerPageChange={onRowsPerPageChange}
                        />
                      </div>
                    );
                  },
                }}
              />
            </TabPanel>
          </Tabs>
        </div>
      </>
    );
  }
}
export default withRouter(AccountEventList);
